import { useMutation } from "react-query";
import downloadDisbursementCSV from "../services/downloadDisbursementCSV";

function useDownloadDisbursementCSV() {
  return useMutation(["download-disbursement-csv"], downloadDisbursementCSV);
}

export default useDownloadDisbursementCSV;